export default "__VITE_ASSET__a4688c11__"